// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type PaymentInfoProps = {
  label: string,
  children: string,
}

export function PaymentInfo({label, children}: PaymentInfoProps): Node {
  return (
    <PaymentInfoItemWrapper>
      <PaymentInfoItem>
        <PaymentInfoItemLabel>{label}</PaymentInfoItemLabel>
        <PaymentInfoItemValue>{children}</PaymentInfoItemValue>
      </PaymentInfoItem>
    </PaymentInfoItemWrapper>
  );
}

const PaymentInfoItemWrapper = styled.div`
  width: 50%;
  text-align: center;
  &:first-child {
    border-right: 1px solid #cbcbcb;
  }
`;

const PaymentInfoItem = styled.dl`
  font-family: ${props => props.theme.fontFamily.display};
  font-weight: 400;
  display: inline-block;
  flex-direction: column;
  width: auto;
  justify-content: space-around;
  flex-grow: 1;
  text-align: left;
  color: #738093;
`;

const PaymentInfoItemLabel = styled.dt`
  font-size: 16px;
`;

const PaymentInfoItemValue = styled.dd`
  font-size: 22px;
`;
